import { GenericEmptyState } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/generic-empty-state';

export function NetImpactLensEmptyState() {
  // const ctx = useNetImpactLensContext();

  return <GenericEmptyState dataTitle="net impact quantification" />;
}
